import { render, staticRenderFns } from "./Media__Caption.vue?vue&type=template&id=a86cf374&lang=pug&"
import script from "./Media__Caption.vue?vue&type=script&lang=js&"
export * from "./Media__Caption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports